import type { ShareUserProfileFragment } from "~/__generated__/graphql"

export type SocialKind = "instagram" | "x" | "tiktok" | "snapchat" | "bluesky"

export type SocialLink = { kind: SocialKind; label: string; href: string }

const cleanHandle = (handle: string) => handle.trim().replace(/^@/, "")

const blueskyHandle = (handle: string) => (handle.includes(".") ? handle : `${handle}.bsky.social`)

const SOCIALS: Array<{ kind: SocialKind; label: string; href: (handle: string) => string }> = [
  { kind: "instagram", label: "Instagram", href: (h) => `https://instagram.com/${h}` },
  { kind: "x", label: "X", href: (h) => `https://x.com/${h}` },
  { kind: "tiktok", label: "TikTok", href: (h) => `https://tiktok.com/@${h}` },
  { kind: "snapchat", label: "Snapchat", href: (h) => `https://snapchat.com/add/${h}` },
  {
    kind: "bluesky",
    label: "Bluesky",
    href: (h) => `https://bsky.app/profile/${blueskyHandle(h)}`,
  },
]

export const socialLinks = (profile: ShareUserProfileFragment): SocialLink[] =>
  SOCIALS.flatMap(({ kind, label, href }) => {
    const handle = cleanHandle(profile[kind] ?? "")
    return handle ? [{ kind, label, href: href(encodeURIComponent(handle)) }] : []
  })

export const safeWebUrl = (url: string | null | undefined): URL | null => {
  const trimmed = url?.trim()
  if (!trimmed) return null
  try {
    const parsed = new URL(/^[a-z][a-z\d+.-]*:/i.test(trimmed) ? trimmed : `https://${trimmed}`)
    return parsed.protocol === "https:" || parsed.protocol === "http:" ? parsed : null
  } catch {
    return null
  }
}

export const displayWebUrl = (url: URL): string =>
  `${url.host.replace(/^www\./, "")}${url.pathname === "/" ? "" : url.pathname}`
